import React, { useContext, useEffect, useState } from "react";
import UnderContractPanel from "./UnderContractPanel/UnderContractPanel";
import { AppContext } from "../../../AppContext";

const UnderContract = ({ device }) => {
  const {
    matrixData,
    teamMemberSelected,
    userTeam,
    setTeamFilter,
    userName,
  } = useContext(AppContext);

  let underContractList = [];
  if (matrixData[0].Request === "No Request") {
    underContractList = (
      <div className="loading">Click "Account" to login :)</div>
    );
  } else {
    const underContractData = matrixData[0]["UnderContract"];
    const filteredData = JSON.parse(underContractData).filter(
      (e) =>
        e.MtgPlanner_CRM__Status__c === "Under Contract" ||
        e.MtgPlanner_CRM__Status__c === "Registered" ||
        e.MtgPlanner_CRM__Status__c === "Submitted" ||
        e.MtgPlanner_CRM__Status__c === "Suspended" ||
        e.MtgPlanner_CRM__Status__c === "Conditionally Approved" ||
        e.MtgPlanner_CRM__Status__c === "Clear to Close" ||
        e.MtgPlanner_CRM__Status__c === "Docs Out" ||
        e.MtgPlanner_CRM__Status__c === "Closed"
    );
    filteredData.sort(
      (a, b) =>
        new Date(a["MtgPlanner_CRM__Est_Closing_Date__c"]) -
        new Date(b["MtgPlanner_CRM__Est_Closing_Date__c"])
    );

    if (filteredData.length <= 0) {
      underContractList = (
        <div className="loading">No transactions under contract</div>
      );
    } else {
      underContractList = filteredData.map((e, index) => {
        return (
          <UnderContractPanel
            key={index}
            index={index}
            clientName={
              e.MtgPlanner_CRM__Borrower_First_Name__c +
              " " +
              e.Borrower_Last_Name__c
            }
            closingDate={e.MtgPlanner_CRM__Est_Closing_Date__c}
            status={e.MtgPlanner_CRM__Status__c}
            address={e.MtgPlanner_CRM__Property_Address__c}
            cityState={
              e.MtgPlanner_CRM__Property_City__c +
              ", " +
              e.MtgPlanner_CRM__Property_State__c +
              " " +
              e.MtgPlanner_CRM__Property_Postal_Code__c
            }
            titleStatus={e.Title_Order_Progress__c}
            hoiStatus={e.HOI_Order_Progress__c}
            appraisalStatus={e.Appraisal_Order_Progress__c}
            appraisalInspectionDate={e.Appraisal_Inspection_Date__c}
            condoDocsStatus={e.Condo_Docs_Order_Progress__c}
            propertyType={e.MtgPlanner_CRM__Property_Type__c}
            loanOfficer={e.Loan_Officer__c}
            loanOfficerEmail={e.Loan_Officer_Email__c}
            loanEngineer={e.Loan_Engineer_Name__c}
            loanEngineerEmail={e.Loan_Engineer_Email__c}
            loanProcessor={e.Processor_Name__c}
            loanProcessorEmail={e.Processor_Email__c}
            floifyId={e.Floify_ID__c}
            appraisalDeadlineDate={e.Appraisal_Contract_Deadline__c}
            condoDocsDeadlineDate={e.Condo_Docs_Contract_Deadline__c}
            hoiDeadlineDate={e.HOI_Contract_Deadline__c}
            inspectionResolutionDeadlineDate={
              e.Inspection_Resolution_Deadline__c
            }
            loanAvailabilityDeadlineDate={e.Loan_Termination__c}
            titleDeadlineDate={e.Title_Contract_Deadline__c}
            userType={localStorage.getItem("userType")}
            buyersAgent={e.Buyers_Agent_Name__c}
            appraisalValue={e.Appraisal_Value__c}
            appraisalCondition={e.Appraisal_Condition__c}
            id={e.Id}
            agentEmails={e.Buyers_Agent_Email__c}
            coAgentName={e.X2nd_Buyer_s_Agent_Name__c}
          />
        );
      });
    }
  }

  return (
    <>
      <div className={`Application-tab Clients  ${device}`}>
        <div className="fullWidth tenPx"></div>
        <div className="filters">
          {userTeam ? (
            <div
              className={`filter-panel ${
                userName == teamMemberSelected ? "noFilterText" : null
              }`}
              onClick={() => {
                setTeamFilter("");
              }}
            >
              {teamMemberSelected}
            </div>
          ) : null}
        </div>
        {underContractList}
        <div className="twentyFivePx"></div>
      </div>
    </>
  );
};

export default UnderContract;
